import { ExecuteMonitorParamsDTO, MonitoringExecutor } from '@meshwatch/types';
import * as Yup from 'yup';

import { typeErrorHandler, validate } from '../../shared/validation';
import { ValidationResponse } from '../../shared/validation/types';

const executorTypeErrorHandler = (params: Partial<Yup.TestMessageParams>): string => {
  return typeErrorHandler('Executor', params);
};

export const EXECUTE_MONITOR_SCHEMA_OBJECT = {
  endpoint: Yup.string().required('Endpoint is required so we know where to send our requests'),
  type: Yup.string()
    .oneOf(['latency-check', 'https-check', 'certificate-check'])
    .required('Monitor type is required') as Yup.Schema<MonitoringExecutor>,
};

const EXECUTE_MONITOR_SCHEMA = Yup.object()
  .shape(EXECUTE_MONITOR_SCHEMA_OBJECT)
  .typeError(executorTypeErrorHandler);

export function validateExecuteMonitorPayload(
  payload: ExecuteMonitorParamsDTO
): Promise<ValidationResponse<ExecuteMonitorParamsDTO>> {
  return validate<ExecuteMonitorParamsDTO>(EXECUTE_MONITOR_SCHEMA, payload);
}
